<div class=" dropdown dropdown-bottom lg:dropdown-right">
  <!-- Trigger -->
  <div tabindex="0" role="button"
    class="relative card px-3 pb-2 pt-1 transition  flex flex-row items-center gap-4 min-w-60 cursor-pointer">

    <span class="material-symbols-outlined text-base opacity-70">grid_view</span>

    <div class="-translate-y-0.5 flex-1 flex flex-col min-w-0 mx-2">
      <h5 class=" leading-6 tracking-wide text-[0.6rem] text-base-content/50">Active Workspace</h5>
      <h3 class="-translate-y-0.5 text-sm font-medium truncate leading-tight">{{ activeWorkspace()?.normalizedName ?? 'Select...' }}
      </h3>
    </div>

    <span class="material-symbols-outlined text-base opacity-40">expand_more</span>
  </div>

  <!-- Dropdown -->
  <ul tabindex="0" class="menu dropdown-content z-1  w-96
             bg-base-100/5 backdrop-blur-md
             shadow-xl rounded
             border border-base-100/15 lg:ml-3 lg:mt-0 mt-3">

    <!-- Search -->
    <li class="relative mb-2">
      <span class="material-symbols-outlined absolute left-2 top-1/2 -translate-y-1/2 text-sm">search</span>
      <input #input type="text" placeholder="Search workspaces..." [ngModel]="searchQuery()"
        (ngModelChange)="onSearchUpdated($event)"
        class="text-base-100/90 w-full input input-sm bg-base-100/10 border border-base-300/10 focus:border-base-300/30 focus:outline-none pl-12 pr-3 rounded text-sm" />
    </li>
    <!-- Workspaces list -->
    <div class="flex flex-col gap-2 max-h-96 overflow-y-auto max-w-full">
      @for (w of items(); track w.id) {
      <li>
        <button (click)="setActiveWorkspace(w.id)" class="p-0! flex-1 flex items-center rounded w-full text-left
                   hover:bg-base-100/10 transition-colors" [class.active]="activeWorkspace()?.id === w.id">

          <!-- Avatar -->
          <div [class.active]="activeWorkspace()?.id === w.id"
            class="h-9 w-9 rounded bg-base-100/20 flex items-center justify-center font-semibold text-xs shrink-0 border border-base-300/20">
            {{ w.displayName.substring(0, 2).toUpperCase() }}
          </div>

          <!-- Content -->
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium truncate leading-tight">
              {{ w.normalizedName }}
            </p>
          </div>

          <!-- Check icon -->
          @if (activeWorkspace()?.id === w.id) {
          <span class="material-symbols-outlined text-primary/80 text-lg">check_circle</span>
          }
        </button>
      </li>
      } @empty {
      <li class="px-4 py-8 text-center text-sm opacity-60">
        No workspaces found
      </li>
      }
    </div>
  </ul>
</div>